import FactoryComponents from '../../../../../factory/components/FactoryComponents.js';
import {
    getPersonDetail, getPersonPx, getPersonZs, getPersonKs,
    getPersonYj, getApplicantSelect, getPersonDetailNew
} from "@/api/processManager"
import {downLoadDocument} from '@/api/downLoad'

const root = {}
export default root
root.name = 'contractPersonList';
root.data = {
    //人员操作
    fileList1: [],
    fileList2: [],
    fileList3: [],
    userData: {
        userDataTableTitle: [{
            title: '姓名',
            key: 'name',
        },
            {
                title: '头像',
                slot: 'header',
                width: 100,
            },
            {
                title: '性别',
                slot: 'sex',
                width: 100,
            },
            {
                title: '工号',
                key: 'empNo',
            },
            {
                title: '承包商',
                key: 'contractorName'
            },
            {
                title: '部门',
                slot: 'dept',
            },
            {
                title: '岗位',
                slot: 'job',
            },
            {
                title: '操作',
                slot: 'action',
                width: 150,
            },
        ],
        //人员数据
        userData: {
            data: [],
            //总页数
            total: 1,
            //每页多少行
            limit: 10,
            //当前页数
            thisPage: 1,
            //名称
            name: ''
        },
        //人员操作时所需的部门数据
        deptData: {
            data: []
        },
		//承诺卡数据
        promiseCard: [],
        //应急卡
        emergencyCard: [],
        //应知卡
        shouldknowCard: [],
        //账号信息
        accountData: [],
        //性别选择
        sexData: [{
            id: 1,
            name: '男'
        }, {
            id: 2,
            name: '女'
        }, {
            id: 0,
            name: '未知'
        }],
        //当前操作的人员数据
        thisOperaData: {
            image: '',
            promiseCardId: '',
            shouldKnowId: '',
            emergencyId: '',
            empType: '',
            phone: '',
            nationality: '',
            healthCondition: '',
            education: '',
            specialty: '',
            graduateInstitutions: '',
            cerType: '',
            idNumber: '',
            postalCode: '',
            company: '',
            joinWorkTime: '',
            jobResumeName: '',
            jobResumeUrl: '',
            placeOfDomicile: '',
            workPlace: '',
            remark: ''
        },
        //显示人员弹出框
        showModal: false,
        //点击保存后的操作
        httpRequest: null,
    },
    // 风险等级数组
    riskLevelArr: [
        {label: "一级", value: 1},
        {label: "二级", value: 2},
        {label: "三级", value: 3},
        {label: "四级", value: 4}
    ],
    // 安全指示标示数组
    saftyArr: [
        {label: '指示标志', value: 1},
        {label: '警示作业安全警示标志', value: 2},
        {label: '逃生避难警示标志', value: 3},
        {label: '风向警示标志', value: 4},
    ],
    // 人员详情的一些数据
    dialogVisible: false,
    promise: null,
    emergency: null,
    should: null,
    activeName: 'first',
    personObj: {},
    tableDataPx: [],
    tableDataZs: [],
    tableDataKs: [],
    tableDataYj: [],
    tableDataLearn: [],
    totalYj: 0,
    limitYj: 10,
    curPageYj: 1,
    // 承包商的列表（查询表格和新增编辑的时候要用）
    contractList: [],
    model8: '', // 列表承包商id
    model9: '', // 新增。编辑承包商id

    // 已上传的文件（工作简历）
    workFileList: [],
    // 人员类型
    empTypeList: [
        {id: 1, name: '员工'},
        {id: 2, name: '带班领导'},
        {id: 3, name: '分管领导'},
        {id: 4, name: '安全管理部门负责人'},
        {id: 5, name: '车间主任'},
        {id: 6, name: '安全管理人员'},
        {id: 7, name: '特种作业人员'},
        {id: 8, name: '外来作业人员'},
        {id: 9, name: '包保责任人' }
    ],
    // 证件类型
    cerTypeList: [
        {id: 1, name: '居民身份证'},
        {id: 2, name: '军人证'},
        {id: 3, name: '港澳台居民身份证'},
        {id: 4, name: '华侨身份证'},
        {id: 5, name: '外籍护照'},
        {id: 6, name: '其他'},
    ],
}
root.methods = {
    handleChange1(file, fileList) {
        this.fileList1 = fileList.slice(-3);
    },
    handleChange2(file, fileList) {
        this.fileList2 = fileList.slice(-3);
    },
    handleChange3(file, fileList) {
        this.fileList3 = fileList.slice(-3);
    },
    handleChangeWork(file, fileList) {
        this.workFileList = fileList
    },
    handleExceedWork(file, fileList) {
        this.$message.warning('限制上传一个文件')
    },
    handleRemoveWork(file, fileList) {
        this.workFileList = fileList
    },
    // 人员详情按钮
    userDetail(row) {
        // console.log(row)
        this.dialogVisible = true
        this.totalYj = 0
        this.curPageYj = 1
        this.getDetail(row.id)
        this.getPx(row.id)
        this.getZs(row.id)
        // this.getKs(row.id)
    },
    // 关闭人员详情弹窗
    closeDia() {
        this.dialogVisible = false
    },
    // 通过人员id查询人员详情
    getDetail(val) {
        getPersonDetail({id: val}).then(res => {
            this.personObj = {...res.body.data}
        })
        getPersonDetailNew(val).then(res => {
            this.emergency = res.body.data.emergency
            this.promise = res.body.data.promise
            this.should = res.body.data.should
            // this.personObj = {...res.body.data}
            // this.getYj() // 写在这里调用应急卡是为了调了人员详情之后 拿到人员的应急卡id,不然翻页的时候拿不到id
        })

    },
    // 培训记录
    getPx(val) {
        getPersonPx({id: val, limit: 10, curPage: 1}).then(res => {
            // console.log(res.body.data)
            this.tableDataPx = res.body.data.cultivateRecords
            this.tableDataKs = res.body.data.questionnaireVos
            this.tableDataLearn = res.body.data.learnVos
        })
    },
    // 个人证书
    getZs(val) {
        getPersonZs({id: val, limit: 10, curPage: 1}).then(res => {
            this.tableDataZs = res.body.data
        })
    },
    // 考试
    // getKs(val) {
    //   getPersonKs({id: val, limit: 10, curPage: 1}).then(res => {
    //     this.tableDataKs = res.body.data
    //   })
    // },
    // 应急卡
    getYj(val) {
        getPersonYj({curPage: this.curPageYj, limit: this.limitYj, id: this.personObj.emergencyId}).then(res => {
            this.tableDataYj = res.body.data
            this.totalYj = res.body.cum
        })
    },
    // 应急卡分页
    handleChangeYj(val) {
        this.curPageYj = val
        this.getYj()
    },

    //初始化人员操作时岗位的选择数据
    initSelectUserJobDChooseData: function () {
        let jobs = [];
        if (this.userData.thisOperaData.depId) {
            this.userData.deptData.data.forEach((item, index) => {
                if (this.userData.thisOperaData.depId === item.id) {
                    jobs = item.jobVos;
                }
            });
        }
        return jobs;
    },

    handleAvatarSuccess: function (res, file) {
        this.userData.thisOperaData = {...this.userData.thisOperaData};
        this.userData.thisOperaData.image = res.data;
    },

    userExcelImportSuccess: function () {
        this.getUserData(this.userData.userData.thisPage);
        this.$refs.userExcel.clearFiles();
    },

    //编辑、新增人员调用方法
    operaUserData: function (data) {
        this.fileList1 = [];
        this.fileList2 = [];
        this.fileList3 = [];
        this.workFileList = []
        if (data) {
            let newObj = {...data}
            for (let m in newObj) {
                if (newObj[m] === 'null' || newObj[m] === 'undefined' || newObj[m] === undefined) {
                    newObj[m] = null
                }
            }
            this.userData.thisOperaData = {...newObj};
            // this.userData.thisOperaData = { ...data};
            this.model9 = data.contractorId
            this.userData.httpRequest = this.updateUser;
            // let promiseCard = JSON.parse(this.userData.thisOperaData.promiseCard);
            // if (promiseCard && promiseCard.length >0){
            // 	for (let i = 0; i < promiseCard.length; i++) {
            // 		let promiseCardElement = promiseCard[i];
            // 		let file = {
            // 			response:{ data: promiseCardElement.fileUrl },
            // 			name: promiseCardElement.fileName
            // 		}
            // 		this.fileList1.push(file);
            // 	}
            // }

            // shouldKnowCard = JSON.parse(this.userData.thisOperaData.shouldKnowCard);
            // let shouldKnowCard = JSON.parse(this.userData.thisOperaData.shouldKnowCard);
            // if (shouldKnowCard && shouldKnowCard.length >0){
            // 	for (let i = 0; i < shouldKnowCard.length; i++) {
            // 		let promiseCardElement = shouldKnowCard[i];
            // 		let file = {
            // 			response:{ data: promiseCardElement.fileUrl },
            // 			name: promiseCardElement.fileName,
            // 		}
            // 		this.fileList2.push(file);
            // 	}
            // }
            // let emergencyCard = JSON.parse(this.userData.thisOperaData.emergencyCard);
            // if (emergencyCard && emergencyCard.length >0){
            // 	for (let i = 0; i < emergencyCard.length; i++) {
            // 		let promiseCardElement = emergencyCard[i];
            // 		let file = {
            // 			response:{ data: promiseCardElement.fileUrl },
            // 			name: promiseCardElement.fileName
            // 		}
            // 		this.fileList3.push(file);
            // 	}
            // }
            if (data.jobResumeUrl !== '' && data.jobResumeUrl !== null & data.jobResumeUrl !== 'null'
                && data.jobResumeUrl !== undefined && data.jobResumeUrl !== 'undefined') {
                this.workFileList.push({
                    name: data.jobResumeName,
                    response: {data: data.jobResumeUrl}
                })
            }

        } else {
            this.userData.thisOperaData = {
                image: '',
                promiseCardId: '',
                shouldKnowId: '',
                emergencyId: '',
                empType: '',
                phone: '',
                nationality: '',
                healthCondition: '',
                education: '',
                specialty: '',
                graduateInstitutions: '',
                cerType: '',
                idNumber: '',
                postalCode: '',
                company: '',
                // joinWorkTime: '',
                jobResumeName: '',
                jobResumeUrl: '',
                placeOfDomicile: '',
                workPlace: '',
                remark: ''
            };
            // this.$set(this.userData.thisOperaData, 'joinWorkTime', '')
            this.userData.thisOperaData.sex = 1;
            this.userData.httpRequest = this.addUser;
        }
        this.userData.showModal = true;
    },

    //获取人员
    getUserData: function (page, model) {
        const that = this;
        this.userData.userData.thisPage = page
        let formdata = new FormData();
        formdata.append("curPage", page);
        formdata.append("limit", this.userData.userData.limit);
        formdata.append("name", this.userData.userData.name);
        formdata.append("type", 1)
        if (model) {
            formdata.append("contractorId", this.model8)
        }
        this.componentsMoudel.startPost('/employee/contractor_empList', formdata, true).then(res => {
            that.userData.userData.total = res.body.cum;
            that.userData.userData.thisPage = res.body.page;
            that.userData.userData.data = res.body.data;
        })
    },

    // 获取对应厂商的人员
    contractChange(value) {
        this.getUserData(1, value)
    },


    //新增人员
    addUser: function () {
        if (!this.checkUserData()) {
            return;
        }
        const that = this;
        let formdata = new FormData();
        // formdata.append("name", this.userData.thisOperaData.name);
        // formdata.append("empNo", this.userData.thisOperaData.empNo);

        // formdata.append("depId", this.userData.thisOperaData.depId);
        // formdata.append("sex", this.userData.thisOperaData.sex);
        // formdata.append("image", this.userData.thisOperaData.image);

        // formdata.append('empType', this.userData.thisOperaData.empType);
        // formdata.append('phone', this.userData.thisOperaData.phone);
        // formdata.append('nationality', this.userData.thisOperaData.nationality);
        // formdata.append('healthCondition', this.userData.thisOperaData.healthCondition);
        // formdata.append('education', this.userData.thisOperaData.education);
        // formdata.append('specialty', this.userData.thisOperaData.specialty);
        // formdata.append('graduateInstitutions', this.userData.thisOperaData.graduateInstitutions);
        // formdata.append('cerType', this.userData.thisOperaData.cerType);
        // formdata.append('idNumber', this.userData.thisOperaData.idNumber);
        // formdata.append('postalCode', this.userData.thisOperaData.postalCode);
        // formdata.append('company', this.userData.thisOperaData.company);
        // formdata.append('joinWorkTime', this.userData.thisOperaData.joinWorkTime);
        // formdata.append('placeOfDomicile', this.userData.thisOperaData.placeOfDomicile);
        // formdata.append('workPlace', this.userData.thisOperaData.workPlace);
        // formdata.append('remark', this.userData.thisOperaData.remark);
        // formdata.append("promiseCardId", this.userData.thisOperaData.promiseCardId==null?0:this.userData.thisOperaData.promiseCardId);
        // formdata.append("shouldKnowId", this.userData.thisOperaData.shouldKnowId==null?0:this.userData.thisOperaData.shouldKnowId);
        // formdata.append("emergencyId", this.userData.thisOperaData.emergencyId==null?0:this.userData.thisOperaData.emergencyId);
        // formdata.append("password", this.userData.thisOperaData.password);
        // formdata.append("userId", this.userData.thisOperaData.userId==null?0:this.userData.thisOperaData.userId);
        // formdata.append("positioningDeviceNumber", this.userData.thisOperaData.positioningDeviceNumber);
        let obj = {...this.userData.thisOperaData}
        for (let i in obj) {
            if (i !== 'jobVo' && i !== 'departmentVo' && i !== 'shouldKnowCardVo' && i !== 'emergencyCardVo' && i !== 'promiseCardVo') {
                if (obj[i] !== null && obj[i] !== 'null' && obj[i] !== undefined && obj[i] !== 'undefined') {
                    formdata.append(i, obj[i])
                }
            }
        }
        formdata.append('contractorId', this.model9)
        if (this.userData.thisOperaData.password === "" ||
            this.userData.thisOperaData.password === null ||
            this.userData.thisOperaData.password === undefined) {
            this.userData.thisOperaData.password = "";
        }
        if (this.userData.thisOperaData.jobId === undefined) {
            formdata.append("jobId", 0);
        } else {
            formdata.append("jobId", this.userData.thisOperaData.jobId);
        }

        if (this.fileList1.length > 0) {
            let fileArray = [];
            for (let item in this.fileList1) {
                let fileInfo = {};
                fileInfo.fileName = this.fileList1[item].name;
                fileInfo.url = this.fileList1[item].response.data;
                fileArray.push(fileInfo);
            }
            formdata.append("promiseCard", JSON.stringify(fileArray));
        }
        if (this.fileList2.length > 0) {
            let fileArray = [];
            for (let item in this.fileList2) {
                let fileInfo = {};
                fileInfo.fileName = this.fileList2[item].name;
                fileInfo.url = this.fileList2[item].response.data;
                fileArray.push(fileInfo);
            }
            formdata.append("shouldKnowCard", JSON.stringify(fileArray));
        }
        if (this.fileList3.length > 0) {
            let fileArray = [];
            for (let item in this.fileList3) {
                let fileInfo = {};
                fileInfo.fileName = this.fileList3[item].name;
                fileInfo.url = this.fileList3[item].response.data;
                fileArray.push(fileInfo);
            }
            formdata.append("emergencyCard", JSON.stringify(fileArray));
        }
        if (this.workFileList.length > 0) {
            formdata.append('jobResumeName', this.workFileList[0].name)
            formdata.append('jobResumeUrl', this.workFileList[0].response.data)
        }
        this.componentsMoudel.startPost('/employee/saveMy', formdata, true).then(res => {
            that.getUserData(that.userData.userData.thisPage);
            this.fileList1 = [];
            this.fileList2 = [];
            this.fileList3 = [];
            that.userData.showModal = false;
        })
    },

    //编辑人员
    updateUser: function () {
        if (!this.checkUserData()) {
            return;
        }
        const that = this;
        let formdata = new FormData();
        // formdata.append("name", this.userData.thisOperaData.name);
        // formdata.append("empNo", this.userData.thisOperaData.empNo);
        // formdata.append("depId", this.userData.thisOperaData.depId);
        // formdata.append("sex", this.userData.thisOperaData.sex);
        // formdata.append("id", this.userData.thisOperaData.id);
        // formdata.append("image", this.userData.thisOperaData.image);
        // formdata.append("password", this.userData.thisOperaData.password);
        // formdata.append("contractorId", this.model9)
        // formdata.append("positioningDeviceNumber", this.userData.thisOperaData.positioningDeviceNumber);
        // formdata.append("promiseCardId", this.userData.thisOperaData.promiseCardId==null?0:this.userData.thisOperaData.promiseCardId);
        // formdata.append("shouldKnowId", this.userData.thisOperaData.shouldKnowId==null?0:this.userData.thisOperaData.shouldKnowId);
        // formdata.append("emergencyId", this.userData.thisOperaData.emergencyId==null?0:this.userData.thisOperaData.emergencyId);
        // formdata.append("userId", this.userData.thisOperaData.userId || '');
        // formdata.append('empType', this.userData.thisOperaData.empType);
        // formdata.append('phone', this.userData.thisOperaData.phone);
        // formdata.append('nationality', this.userData.thisOperaData.nationality);
        // formdata.append('healthCondition', this.userData.thisOperaData.healthCondition);
        // formdata.append('education', this.userData.thisOperaData.education);
        // formdata.append('specialty', this.userData.thisOperaData.specialty);
        // formdata.append('graduateInstitutions', this.userData.thisOperaData.graduateInstitutions);
        // formdata.append('cerType', this.userData.thisOperaData.cerType);
        // formdata.append('idNumber', this.userData.thisOperaData.idNumber);
        // formdata.append('postalCode', this.userData.thisOperaData.postalCode);
        // formdata.append('company', this.userData.thisOperaData.company);
        // formdata.append('joinWorkTime', this.userData.thisOperaData.joinWorkTime);
        // formdata.append('placeOfDomicile', this.userData.thisOperaData.placeOfDomicile);
        // formdata.append('workPlace', this.userData.thisOperaData.workPlace);
        // formdata.append('remark', this.userData.thisOperaData.remark);
        formdata.append('contractorId', this.model9)
        let obj = {...this.userData.thisOperaData}
        for (let i in obj) {
            if (i !== 'jobVo' && i !== 'departmentVo' && i !== 'shouldKnowCardVo' && i !== 'emergencyCardVo' && i !== 'promiseCardVo') {
                if (obj[i] !== null && obj[i] !== 'null' && obj[i] !== undefined && obj[i] !== 'undefined') {
                    formdata.append(i, obj[i])
                }
            }
        }

        if (this.userData.thisOperaData.jobId === undefined) {
            formdata.append("jobId", 0);
        } else {
            formdata.append("jobId", this.userData.thisOperaData.jobId);
        }
        if (this.fileList1.length > 0) {
            let fileArray = [];
            for (let item in this.fileList1) {
                let fileInfo = {};
                fileInfo.fileName = this.fileList1[item].name;
                fileInfo.url = this.fileList1[item].response.data;
                fileArray.push(fileInfo);
            }
            formdata.append("promiseCard", JSON.stringify(fileArray));
        }
        if (this.fileList2.length > 0) {
            let fileArray = [];
            for (let item in this.fileList2) {
                let fileInfo = {};
                fileInfo.fileName = this.fileList2[item].name;
                fileInfo.url = this.fileList2[item].response.data;
                fileArray.push(fileInfo);
            }
            formdata.append("shouldKnowCard", JSON.stringify(fileArray));
        }
        if (this.fileList3.length > 0) {
            let fileArray = [];
            for (let item in this.fileList3) {
                let fileInfo = {};
                fileInfo.fileName = this.fileList3[item].name;
                fileInfo.url = this.fileList3[item].response.data;
                fileArray.push(fileInfo);
            }
            formdata.append("emergencyCard", JSON.stringify(fileArray));
        }
        if (this.workFileList.length > 0) {
            formdata.append('jobResumeName', this.workFileList[0].name)
            formdata.append('jobResumeUrl', this.workFileList[0].response.data)
        }
        this.componentsMoudel.startPost('/employee/update', formdata, true).then(res => {
            that.getUserData(that.userData.userData.thisPage);
            this.fileList1 = [];
            this.fileList2 = [];
            this.fileList3 = [];
            that.userData.showModal = false;
        })
    },

    //删除人员
    delUser: function (data) {
        const that = this;
        this.$confirm(`删除 "${data.name}", 是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.componentsMoudel.startDel('/employee/delete/' + data.id, data, true).then(res => {
                if (this.userData.userData.data.length <= 1 && this.userData.userData.thisPage > 1) {
                    this.userData.userData.thisPage -= 1
                }
                that.getUserData(that.userData.userData.thisPage);
                this.$message.success('删除成功')
            })
        }).catch(() => {
            return
        });
    },

    checkUserData: function () {
        if (this.userData.thisOperaData.name === '' ||
            this.userData.thisOperaData.name === null ||
            this.userData.thisOperaData.name === undefined) {
            this.$message({
                message: '请输入名称',
                type: 'error'
            });
            return false;
        }
        if (this.userData.thisOperaData.empNo === '' ||
            this.userData.thisOperaData.empNo === null ||
            this.userData.thisOperaData.empNo === undefined) {
            this.$message({
                message: '请输入工号',
                type: 'error'
            });
            return false;
        }
        if (this.userData.thisOperaData.positioningDeviceNumber === '' ||
            this.userData.thisOperaData.positioningDeviceNumber === null ||
            this.userData.thisOperaData.positioningDeviceNumber === undefined) {
            this.$message({
                message: '请输入设备编号',
                type: 'error'
            });
            return false;
        }
        if (this.userData.thisOperaData.depId === 0 ||
            this.userData.thisOperaData.depId === null ||
            this.userData.thisOperaData.depId === undefined) {
            this.$message({
                message: '请输入选择部门',
                type: 'error'
            });
            return false;
        }
        return true;
    },

    //获取部门
    getUserInDeptData: function (page) {
        const that = this;
        this.componentsMoudel.startGet('/businessManagement/departmentManagement/getAll', null, true).then(res => {
            that.userData.deptData.data = res.body.data;
        })
    },

    //获取承诺卡
    getPromiseCard: function () {
        const that = this;
        this.componentsMoudel.startGet('/promisecard/getAll', null, true).then(res => {
            that.userData.promiseCard = res.body.data;
        })
    },

    //获取应急卡
    getEmergencyCard: function () {
        const that = this;
        this.componentsMoudel.startGet('/emergencycard/getAll', null, true).then(res => {
            that.userData.emergencyCard = res.body.data;
        })
    },

    //获取应知识卡
    getShouldknowCard: function () {
        const that = this;
        this.componentsMoudel.startGet('/shouldknowcard/getAll', null, true).then(res => {
            that.userData.shouldknowCard = res.body.data;
        })
    },

    //获取账号信息
    getAccountData() {
        const that = this;
        this.componentsMoudel.startGet('/businessManagement/userManagement/getAllUser', null, true).then(res => {
            that.userData.accountData = res.body.data;
        })
    },
    // 下载文件
    downloadBtn(url, name) {
        downLoadDocument(url, name)
    }
}

root.mounted = function () {

    this.getUserData(this.userData.userData.thisPage);
    this.getUserInDeptData();
    this.getPromiseCard();
    this.getEmergencyCard();
    this.getShouldknowCard();
    this.getAccountData();
    getApplicantSelect().then(res => {
        this.contractList = res.body.data
        if (res.body.data && res.body.data.length > 0) {
            this.model9 = res.body.data[0].id
        }
    })
}
FactoryComponents.initComponent(root);
